import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Step } from '../../components/steppers';
import { Audience } from '../../models/audiences';

export type AudienceEditSource = 'manual' | 'prefill';

type AudienceEditState = {
  audience?: Partial<Audience>;
  source?: AudienceEditSource;
  /** One-shot: prefill opened with a meaningful expression — lock expression UI for the wizard session. */
  expressionReadOnly: boolean;
  ui: {
    steps: Step[];
  };
};

export const initialState: AudienceEditState = {
  expressionReadOnly: false,
  ui: {
    steps: [],
  },
};

const audienceEditSlice = createSlice({
  name: 'audienceEdit',
  initialState,
  reducers: {
    stashAudience: (state, action: PayloadAction<Partial<Audience>>) => ({
      ...state,
      audience: { ...state.audience, ...action.payload },
    }),
    clearStashedAudience: (state) => ({
      ...state,
      audience: undefined,
      source: undefined,
      expressionReadOnly: false,
    }),
    setAudienceEditSource: (state, action: PayloadAction<AudienceEditSource | undefined>) => ({
      ...state,
      source: action.payload,
    }),
    setExpressionReadOnly: (state, action: PayloadAction<boolean>) => ({
      ...state,
      expressionReadOnly: action.payload,
    }),
    stashSteps: (state, action: PayloadAction<Step[]>) => ({
      ...state,
      ui: {
        ...state.ui,
        steps: action.payload,
      },
    }),
  },
});

export const { stashAudience, clearStashedAudience, setAudienceEditSource, setExpressionReadOnly, stashSteps } = audienceEditSlice.actions;

export default audienceEditSlice.reducer;
